import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  membersList: []
};

const membersReducerSlice = createSlice({
  name:"members",
  initialState,
  reducers:{
    updateMembers(state,action){
      return{
        ...state,
        membersList: [...action.payload]
      } 
    },
    updateMember(state,action){
      return{
        ...state,
        membersList: state.membersList.map((member) => {
          if (member._id === action.payload.id) {
            return action.data;
          }
          return member;
        })
      }
    },
    logoutUser(state){
      return {
        ...state,
        membersList: []
      };
    }
  }
})

// export const membersReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case UPDATE_MEMBERS: {
//       return {
//         ...state,
//         membersList: [...action.payload]
//       };
//     }
//     case UPDATE_MEMBER: {
//       return {
//         ...state,
//         membersList: state.membersList.map((member) => {
//           if (member._id === action.payload.id) {
//             return action.data;
//           }
//           return member;
//         })
//       };
//     }
//     case LOGOUT_USER: {
//       return {
//         ...state,
//         membersList: []
//       };
//     }
//     default:
//       return state;
//   }
// };


export const membersReducerAction = membersReducerSlice.actions
export const membersReducers = membersReducerSlice.reducer